import React, {useEffect, useState} from "react";
import {HelpHttp} from "helpers/HelpHttp";
import ServiceCrudTable from "./ServiceCrudTable";
import RequestError from "components/RequestError";
import ServiceCrudForm from "./ServiceCrudForm";
import Swal from "sweetalert2";
import {HelpAbility} from "helpers/HelpAbility";
import C from "helpers/HelpConstants";
import {trackPromise} from 'react-promise-tracker';

const {REACT_APP_API} = process.env;
const initialForm = {_id: null, code: '', name: '', description: '', endpoint: '', groupCodes: [], isVisible: null};

const ServiceCrud = () => {
    const [services, setServices] = useState(null);
    const [groups, setGroups] = useState(null);
    const [dataToEdit, setDataToEdit] = useState(null);
    const [form, setForm] = useState(initialForm);
    const [requestError, setRequestError] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    let myAbilities = HelpAbility();
    let api = HelpHttp();
    let url = `${REACT_APP_API}/services`
    let url_groups = `${REACT_APP_API}/serviceGroups`

    const openModal = () => setIsOpen(true);
    const closeModal = () => {
        setForm(initialForm);
        setIsOpen(false);
    }

    useEffect(() => {
        if (dataToEdit && groups) {
            const codeValues = Array.isArray(dataToEdit.groupCodes)
                ? dataToEdit.groupCodes.map((item) => {
                    const isCode = groups.some((g) => g.code === item);
                    if (isCode) return item;

                    const found = groups.find((g) => g.name === item);
                    return found ? found.code : null;
                }).filter(Boolean)
                : [];

            setForm({
                ...dataToEdit,
                groupCodes: codeValues,
            });
        } else if (!dataToEdit) {
            setForm(initialForm);
        }
    }, [dataToEdit, groups]);


    const editData = (el) => {
        openModal();
        setDataToEdit(el);
        setErrors(null);
    }

    const listServices = () => {
        trackPromise(api.get(url).then(res => {
            if (res.err) {
                setServices(null);
                setRequestError(res);
            } else {
                setServices(res);
                setRequestError(null);
            }
        }));
    }

    const listGroups = () => {
        trackPromise(api.get(url_groups).then(res => {
            if (res.err) {
                setGroups(null);
                setRequestError(res);
            } else {
                setGroups(res);
                setRequestError(null);
            }
        }));
    }

    const createData = (data) => {
        closeModal(); 
        console.log(data);
        let options = {body: data, headers: {'content-type': 'application/json'}};

        trackPromise(api.post(url, options).then(res => {
            console.log(res);
            if (res.err) {
                setRequestError(res);
            } else {
                if (res.status) {

                    listServices();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        }));
    }



    const updateData = (data) => {
        closeModal();
        let endPoint = `${url}/${data._id}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};

        trackPromise(api.put(endPoint, options).then(res => {
            if (res.err) {
                setRequestError(res);
            } else {
                if (res.status) {

                    listServices();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        }));
    }
    const deleteData = (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, bórralo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const endPoint = `${url}/${id}`;
                let options = {headers: {'content-type': 'application/json'}};
                trackPromise(api.del(endPoint, options).then(res => {
                    console.log(res);
                    if (res.err) {
                        setRequestError(res);
                    } else {
                        if (res.status) {
                            Swal.fire('¡Eliminado!', res.message, 'success');
                            listServices();
                            // handleReset();
                        } else {
                            setErrors(res.errors);
                        }
                    }
                }));
            }
        });
    }
    const handleReset = (e) => {
        setErrors(null);
        setForm(initialForm);
        setDataToEdit(null);
    }
    let myAbi = HelpAbility();
    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.SERVICE.CREATE) : myAbi.has(C.A.SERVICE.UPDATE);

    useEffect(() => {
        listServices();
        listGroups();
    }, [url]);    
    
    const styles = {
        overlay: {
            position: 'fixed', top: 0, left: 0,
            width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 1000
        },
        modal: {
            background: 'white',
            padding: '2rem',
            borderRadius: '8px',
            position: 'relative',
            width: '500px',
            maxHeight: '90vh',
            overflowY: 'auto'
        },
        closeBtn: {
            position: 'absolute',
            top: '10px', right: '10px',
            background: 'transparent',
            border: 'none',
            fontSize: '1.2rem',
            cursor: 'pointer'
        },
        openBtn: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    };

    return (
        <div className="container">
            <div className="row my-md-4">
                <div className={isVisibleForm() ? 'col-12' : 'col-12'}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3>Listado de Servicios</h3>
                        {(myAbilities.has(C.A.SERVICE.CREATE) || myAbilities.has(C.A.SERVICE.UPDATE)) &&
                            <button onClick={openModal} className="btn btn-primary" style={styles.openBtn}>Crear servicio</button>
                        }
                        {isOpen && (
                            <div style={styles.overlay}>
                                <div style={styles.modal}>
                                    <button onClick={closeModal} style={styles.closeBtn}>✖</button>

                                    <div className="col-12">
                                        <ServiceCrudForm createData={createData} updateData={updateData} handleReset={handleReset}
                                                        setForm={setForm} form={form} initialForm={initialForm}
                                                        groups={groups} setDataToEdit={setDataToEdit} errors={errors}/>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {requestError && <RequestError msg={requestError}/>}

                    {services &&
                    <ServiceCrudTable services={services} editData={editData} deleteData={deleteData}/>}
                </div>
            </div>
        </div>
    );
}
export default ServiceCrud;
